import Vue from 'vue'
import { ToastPlugin, ModalPlugin } from 'bootstrap-vue'
import VueCompositionAPI from '@vue/composition-api'

import VueMoment from 'vue-moment'
import moment from 'moment-timezone'
// require('moment/locale/es')

// import i18n from '@/libs/i18n'
import io from 'socket.io-client'
import useJwt from '@/auth/jwt/useJwt'
import router from './router'
import store from './store'
import App from './App.vue'

// Global Components
import './global-components'

// 3rd party plugins
import '@axios'
import '@/libs/acl'
import '@/libs/portal-vue'
import '@/libs/toastification'
import '@/libs/vue-select'

// Axios Mock Adapter
// import '@/@fake-db/db'

// BSV Plugin Registration
Vue.use(ToastPlugin)
Vue.use(ModalPlugin)
Vue.use(VueMoment, {
  moment,
})

// Composition API
Vue.use(VueCompositionAPI)

// import core styles
require('@core/scss/core.scss')

// import assets styles
require('@/assets/scss/style.scss')

Vue.config.productionTip = false
const token = localStorage.getItem(useJwt.jwtConfig.storageTokenKeyName)
const urlWebsocket = `${process.env.VUE_APP_API_URL}`
const socket = io(urlWebsocket, {
  // add the token to the headers
  auth: {
    token,
  },
})

Vue.prototype.$socket = socket

new Vue({
  router,
  store,
  // i18n,
  render: h => h(App),
}).$mount('#app')
